<template>
  <div>
    <label v-bind="$attrs">{{ label }}</label>
    <div class="checkboxes-group" :style="`grid-gap: ${gap}; grid-template-columns: repeat(${customCols}, auto)`">
      <label class="course-checkbox" v-for="(option, index) in value">
        <input type="checkbox"
               :checked="option.checked"
               @change="change(index)"
        />
        <span></span>
        {{ option[text_key || 'text'] }}
      </label>
    </div>


  </div>
</template>
<style scoped lang="scss">
.checkboxes-group {
  display: grid;
  justify-content: flex-start;
  grid-column-gap: 30px;
  width: 100%;
}
</style>

<script>


export default {
  props: ['value', 'label', 'direction', 'cols', 'gap', 'media_query', 'text_key'],
  mounted() {
    this.$emit('input', this.$props.value);

    if (this.$props.media_query?.length) {
      this.mediaQueryListen()
      this.mediaQueryCalculate()
    }
  },

  unmounted() {
    if (this.$props.media_query?.length) {
      this.mediaQueryRemoveListen()
    }
  },
  data() {
    return {
      opt: this.$props.value,
      customCols: this.$props?.cols,
    }
  },
  computed: {},


  methods: {
    mediaQueryListen() {
      window.addEventListener('resize', this.mediaQueryCalculate);
    },
    mediaQueryRemoveListen() {
      window.removeEventListener('resize', this.mediaQueryCalculate);
    },
    mediaQueryCalculate() {
      const mediaArray = this.$props.media_query.sort((a, b) => a.media - b.media)
      const self = this;
      mediaArray.forEach((screen, index) => {
        if (window.innerWidth > screen.media) {
          self.customCols = screen.cols
        }
      });
    },

    change: function (index) {
      this.opt = this.$props.value.map((item, i) => {

        if (index === i) {
          return {
            ...item,
            checked: !item.checked
          }
        }

        return {
          ...item,
          checked: !!item.checked
        }
      })


      this.$emit('input', this.opt);
    }
  }
}
</script>